<template>
  <b-overlay class="border-bottom">
    <div v-if="type==='card'">
      <b-row class="m-0 bg-dark">
        <b-col
            v-for="{id,text,style} in choicesArray"
            :key="id"
            class="p-0 d-flex justify-content-center align-items-center"
            @click="select(id)"
            :style="{backgroundColor:'white',opacity:style.opacity}">
          <div class="text-center">{{ text }}</div>
        </b-col>
      </b-row>
      <b-row class="m-0 bg-dark">
        <b-col
            class="p-0"
            v-for="{id,img,style} in choicesArray"
            :key="id"
            @click="select(id)"
            :style="{backgroundColor:'white',opacity:style.opacity}">
          <img
              :src="getImgPath(img)"
              alt=""
              class="w-100">
        </b-col>
      </b-row>
    </div>
    <div v-else-if="type==='select'">
      <b-row class="m-0">
        <b-col
            class="p-0 d-flex justify-content-center align-items-center">
          <div class="text-center">{{ choices[0].text }}</div>
        </b-col>
      </b-row>
      <b-row class="m-0">
        <b-select :options="choicesArray"></b-select>
      </b-row>
    </div>

  </b-overlay>
</template>

<script>
export default {
  name   : "lFormRow",
  props  : ["choices", "type", "onchange"],
  data   : function() {
    return {
      choicesArray: this.buildChoicesArray()
    };
  },
  methods: {
    buildChoicesArray() {
      switch (this.type) {
        case "card":
          return this.buildCardChoicesArray();
        case "select":
          return this.buildSelectChoicesArray();
        default:
          return []
      }
    },
    buildCardChoicesArray() {
      return this.choices.map((data, id) => {
        return {id: data.id || id, text: data.text, img: data.img, data, style: {opacity: 1}}
      });
    },
    buildSelectChoicesArray() {
      return this.choices.reduce(
          (prev, data) => [
            ...prev,
            ...(data.list || [])
          ], [])
    },
    select(id) {
      this.onChangeCall(this.choicesArray.find(x => x.id === id).data)
      for (let {...el} of this.choicesArray) {
        if (el.id === id) el.style.opacity = 1
        else el.style.opacity = 0.25
        this.$set(this.choicesArray, el.id, el)
      }
    },
    onChangeCall(data) {
      (this._props.onchange || function() {})(data)
    },
    getImgPath(fileName) {
      return fileName ? require(`../assets/${fileName}.jpg`) : require(`../assets/placeholder.jpg`);
    }
  },
}
//Utils
</script>

<style scoped>

</style>